import React from "react";
// outsource
import { Row, Col, Layout, Tabs } from "antd";
import { URL } from "../00_Nav/url";
// components
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import PayoutSettingGeneralTab from "./component/payout_setting_general_tab";
import PayoutSettingAfterHoursTab from "./component/payout_setting_after_hours_tab";
import PayoutSettingPublicHolidaysTab from "./component/payout_setting_public_holidays_tab";
// style
import "./style.css";

const { Content } = Layout;

const PayoutSettingScreen = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Payout", url: URL.payout },
    { title: "Payout Configs", url: URL.payoutSetting },
  ];

  const tabItems = [
    { key: "general", label: "General", children: <PayoutSettingGeneralTab /> },
    { key: "after-hours", label: "After-Hours", children: <PayoutSettingAfterHoursTab /> },
    { key: "public-holidays", label: "Public Holidays", children: <PayoutSettingPublicHolidaysTab /> },
  ];

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row style={{ marginTop: 16 }}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Tabs defaultActiveKey="general" items={tabItems} />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content ps-content-wrap">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default PayoutSettingScreen;
